<template><div><h1 id="zusagenfakturierung-position" tabindex="-1"><a class="header-anchor" href="#zusagenfakturierung-position"><span>Zusagenfakturierung (Position)</span></a></h1>
<p>Zusagenfakturierung (Position) — Zusagenfakturierung (Position)</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert Positionen für die Zusagenfakturierung.</p>
<p>Pfad: <code v-pre>Personen → Verarbeitungsläufe → Zusagen → Zusagenfakturierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Pos.</dt>
<dd>Positionsnummer, wird vom System in 10-er Schritten vergeben, kann manuell angepasst werden.</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Position.</dd>
<dt>Typ</dt>
<dd>Folgende Typen stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Typ</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ausschluss</td>
<td>Ausschluss aus der Fakturierung</td>
</tr>
<tr>
<td>Drittzahler</td>
<td>Für die Fakturierung von Drittzahler (keine eigene Zusage)</td>
</tr>
<tr>
<td>Eigene Zusage</td>
<td>Für die Fakturierung von eigenen Zusagen (keine Drittzahler)</td>
</tr>
<tr>
<td>Gemischt</td>
<td>Unterstützt alle Typen (Ausschluss, Drittzahler, eigene Zusage)</td>
</tr>
<tr>
<td>Austritt</td>
<td>Erfasst einen Austritt. Idealerweise bei rollenden Mahnungen verwenden, zusammen mit der Filterposition 256. Zu den Positionen mit diesem Typ können, bei den Fakturierungstypen Mahnungen und Mahnungen (rollend) , Austrittsereignisse verknüpft werden.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Zusage</dt>
<dd>Werte gemäss Tabelle <a class="link" href="ft.refdata.tblzusart.html" title="Zusagen">Zusagen</a></dd>
<dt>Zahlungsmodus</dt>
<dd>Zahlungsmodus</dd>
<dt>Filter</dt>
<dd>Personenfilter, dient der Bildung von Untergruppen im Lauf aus den vorhandenen Zusagen.</dd>
<dt>Outputtyp</dt>
<dd>Folgende Outputtypen stehen zur Auswahl:| Outputtyp | Beschreibung |
| --- | --- |
| BAD | Für Zahlungsmodus BAD |
| Dokumentoutput | generiert die Dokumente aus der Fakturierung |
| Datenexport | Für den Export der Daten, Dokumente werden extern erstellt. |
| LSV | Für Zahlungsmodus LSV |</dd>
<dt>Betrag</dt>
<dd>Summe der in dieser Position fakturierten Beträge</dd>
<dt>Anzahl</dt>
<dd>Anzeige der Anzahl berücksichtigter Personen (erscheint erst nach dem Zähllauf bzw. Fakturierungslauf).</dd>
<dt>Verwendung</dt>
<dd>Folgende Werte stehen zur Auswahl:| Verwendung | Beschreibung |
| --- | --- |
| Zusage | Ereignis für die Zusage (RSB) |
| Spende | Ereignis für die Spende (RSS) |
| Spende (Beschenkte) | Ereignis für die Spende für Beschenkten (RSS) |
| Sonstiges | Weitere Ereignisse (RDI) |
| Sonstiges (Beschenkte) | Weitere Ereignisse (RDI) für Beschenkten |</dd>
<dt>Ereignis</dt>
<dd>Auswahl des Ereignisses</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Ereignisses</dd>
<dt>Ereignisposition</dt>
<dd>Auswahl der Ereignisposition</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Ereignisposition</dd>
<dt>Status</dt>
<dd>Status des Ereignisses</dd>
<dt>Kanal</dt>
<dd>Kanal des Ereignisses</dd>
<dt>Dokumentensatz</dt>
<dd>Auswahl des <a class="link" href="ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatzes</a> für die Ausgabe in Dokument-Output.</dd>
<dt>Exportformat</dt>
<dd>Eingabe/Auswahl des Exportformats für den Export der Fakturierungsdaten, nur bei Outputtyp BAD, LSV und Datenexport relevant. Für Kreditkartenbelastungen dient das Exportformat lediglich für die Erstellung einer Liste der Belastungen zur visuellen Kontrolle. Für die Belastung selbst wird kein Exportformat benötigt.</dd>
<dt>Versand</dt>
<dd>Versand</dd>
<dt>Empfänger</dt>
<dd>Empfänger des Outputs</dd>
<dt>Exportdatei</dt>
<dd>Interner Unix-Filename für LSV/DD-File.</dd>
<dt>Drucker</dt>
<dd>Angabe des Druckers, auf den gedruckt werden soll. Wird keine Druckdatei angegeben, dann werden die Daten direkt auf diesen Drucker ausgegeben</dd>
<dt>Textnr.</dt>
<dd>Nummer Text für Mitteilung an Zahlungsempfänger (LSV/DD) gem. Tabelle &quot;Texte zu Zusage-Beitragsfakturierung LSV/BAD&quot;</dd>
<dt>Zahlungsverb.</dt>
<dd>Zahlungsverbindungsnummer gem. Tabelle <a class="link" href="ft.refdata.tblzahlverb.html" title="Zahlungsverbindungen LSV/DD">Zahlungsverbindung</a> .</dd>
<dt>Dokumentencode</dt>
<dd>Dokumentencode</dd>
<dt>Datum auf Brief</dt>
<dd>Datum welches auf den Brief gedruckt wird.</dd>
<dt>Anrede</dt>
<dd>Anrede, Einzel- oder Haushaltsanrede.</dd>
<dt>Anredeset</dt>
<dd>Anredeset, Auswahl aus der Tabelle Anredesets.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="vorschau" tabindex="-1"><a class="header-anchor" href="#vorschau"><span>Vorschau...</span></a></h3>
<p>Mit dieser Funktion werden die Zusagenfakturierungsdokumente zu Kontrollzwecken erstellt und angezeigt.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.zusfak.html" title="Zusagenfakturierung">Zusagenfakturierung</RouteLink></p>
</div></template>


